import axios from 'axios';
import { store } from '@common/store/store';
import { library } from '@common/library/library';
import { errorHandler } from "@common/errorHandler/errorHandler";
import { uStore } from "@common/userStore";

const qs = require('qs');

let loadingRequestsCount = 0;
let loadingRequestsPerSecond = [];
let loadingRequestsPerSecondInterval = 0;
let freezeDetected = false;
let changeLoadingRequestsCount = (decrease) => {
    if (isNaN(parseInt(loadingRequestsCount, 10))) loadingRequestsCount = 0;
    if (decrease) {
        loadingRequestsCount -= 1;
    } else {
        loadingRequestsCount += 1;
    }
};

let cachedRequests = [];
let combine = {
    inSeconds: 1,
    args: {
        'sds_getAvailableFields': ['[2].columns'],
        'sds_getComponentConfig': ['[1]']
    },
    payload: {},
    timeouts: {},
    promises: {},
    resolves: {},
};

/*
* vuex module for sending requests to sDs
* store last requests for repeater
* */
let sDs = {
    namespaced: true,
    state: {
        debug: false,
        usePrepared: false,
        cacheLifeTime: 3, // seconds, 0 - infinity
        preparedRequests: {},
        detectFreeze: true,
        lastRequests: [],
        cachedRequests: {},
        requestModifiedList: {},
        idbRequestModifiedList: {},
        sessionExpiredTimeout: false,
        requestFirstFailTime: {},
        consistentRequests: [],
        consistentRequestsQueue: {}
    },
    getters: {
        getter: /* istanbul ignore next */ function (state) {
            return function (payload) {
                let [property] = Object.values(payload);
                return state[property];
            };
        },
    },
    mutations: {
        mutate: function (state, payload) {
            let [property, value] = Object.values(payload);
            // let tmp = state[property];
            // if (typeof (tmp) === "undefined") {
            //     tmp = {};
            // }
            // tmp = value;
            // state[property] = [];
            // state[property] = tmp;
            state[property] = value;
        },
        /* addRequest: function (state, payload) {
            let [params] = Object.values(payload);
            if (params.type) {
                if (typeof (state.lastRequests[params.type]) === "undefined") {
                    state.lastRequests[params.type] = [];
                }
                let tmp = state.lastRequests[params.type];
                if (tmp.length < 10) { // NOSONAR
                    tmp[tmp.length] = params.value;
                } else {
                    tmp = tmp.slice(1, tmp.length);
                    tmp.push(params.value);
                }
                state.lastRequests[params.type] = [];
                state.lastRequests[params.type] = tmp;
            }
        }, */
        async updateRequestModifiedList(state, payload) {
            if (typeof IS_JEST !== 'undefined') return;
            let projectAllowsCaching = typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'devDash';
            if (!projectAllowsCaching) return;
            let hasServerTimestamps = !library.objIsEmpty(state.requestModifiedList);
            let [requests, updateOnlyInCST] = Object.values(payload);
            if (!Array.isArray(requests)) requests = [requests];
            // populate server timestamps in store
            if (!hasServerTimestamps) {
                // TODO replace this with a global property that stores changes to tracked requests
                let request = await sDs.post('ec_getCstProperty', 'requestModifiedList', true);
                if (request.status === 'success' && request.data) {
                    state.requestModifiedList = JSON.parse(request.data);
                    hasServerTimestamps = true;
                }
            }
            if (!hasServerTimestamps) return;
            // populate Caching timestamps in store
            if (library.objIsEmpty(state.idbRequestModifiedList)) {
                let idbRequest = await library.cachedTransaction('get', 'requestModifiedList');
                if (idbRequest.status !== 'success') {
                    let newList = {};
                    requests.forEach((requestKey) => {
                        newList[requestKey] = false;
                    });
                    library.cachedTransaction('put', 'requestModifiedList', JSON.stringify(newList));
                    idbRequest = await library.cachedTransaction('get', 'requestModifiedList');
                }
                state.idbRequestModifiedList = idbRequest.data;
            }
            let serverTimestamps = state.requestModifiedList;
            let idbTimestamps = state.idbRequestModifiedList;
            requests.forEach((requestKey) => {
                let modifiedTime = Date.now();
                serverTimestamps[requestKey] = modifiedTime;
                idbTimestamps[requestKey] = modifiedTime;
            });
            // put this requests in Caching & Update cstProperty
            if (!updateOnlyInCST) library.cachedTransaction('put', 'requestModifiedList', JSON.stringify(idbTimestamps));
            sDs.post('ec_setCstProperty', 'requestModifiedList', JSON.stringify(serverTimestamps));
        },
    },
    actions: {
        async compareDataAge({ state }, payload) {
            if (typeof IS_JEST !== 'undefined') return false;
            let [requestKey] = Object.values(payload);
            let hasServerTimestamps = !library.objIsEmpty(state.requestModifiedList);
            // populate server timestamps in store
            if (!hasServerTimestamps) {
                // TODO replace this with a global property that stores changes to tracked requests
                let request = await sDs.post('ec_getCstProperty', 'requestModifiedList', true);
                if (request.status === 'success' && request.data) {
                    state.requestModifiedList = JSON.parse(request.data);
                    hasServerTimestamps = true;
                }
            }
            // populate Caching timestamps in store
            if (library.objIsEmpty(state.idbRequestModifiedList)) {
                let idbRequest = await library.cachedTransaction('get', 'requestModifiedList');
                if (idbRequest.status !== 'success') {
                    let newList = {};
                    newList[requestKey] = false;
                    await library.cachedTransaction('put', 'requestModifiedList', JSON.stringify(newList));
                    idbRequest = await library.cachedTransaction('get', 'requestModifiedList');
                }
                state.idbRequestModifiedList = idbRequest.data;
            }
            let idbTimestamps = state.idbRequestModifiedList;
            let serverTimestamps = state.requestModifiedList;
            // Compare the timestamps for isUpdated output
            let isUpdated = !idbTimestamps[requestKey]
                || (hasServerTimestamps // Ignore if we don't have server timestamps
                    && (!serverTimestamps[requestKey] || serverTimestamps[requestKey] !== idbTimestamps[requestKey])
                );
            if (isUpdated) {
                if (serverTimestamps[requestKey]) {
                    // Update local copy
                    idbTimestamps[requestKey] = serverTimestamps[requestKey];
                    library.cachedTransaction('put', 'requestModifiedList', JSON.stringify(idbTimestamps));
                }
                else if (hasServerTimestamps) {
                    // Don't run updateRequestModifiedList if we don't have server timestamps
                    sDs.updateRequestModifiedList([requestKey]);
                }
            }
            return isUpdated;
        },
        responseHandler({ state, commit, dispatch }, payload) {
            let [functionName, functionParams, sDsParams, response, responseStatus] = Object.values(payload);
            if (typeof IS_JEST !== 'undefined') return false;
            let funcNotFoundReg = /^(function .* not found)/i;
            let funcNameEmptyReg = /functionName is empty/i;
            let reloadOnError = typeof VUE_PROJECT_NAME !== 'undefined' && (/* VUE_PROJECT_NAME === 'signin' || */ VUE_PROJECT_NAME === 'importExport' || VUE_PROJECT_NAME === 'devDash');
            let reloadOnSessionExiped = typeof VUE_PROJECT_NAME !== 'undefined' && (VUE_PROJECT_NAME === 'importExport' || VUE_PROJECT_NAME === 'devDash');
            let toastMessage;
            let toastTimeout = 60;
            let result = false;

            let toastMessages = {
                woReload: 'Sorry, there\'s a problem with the service.<br>Our developers have been notified.',
                withReload: 'Sorry, there\'s a problem with the service.<br>Our developers have been notified.<br>Page will <a href="' + location.origin + location.pathname + '" style="color:white;">reload</a> in a 60 seconds'
            };

            if (responseStatus) {
                if (responseStatus === 500) {
                    toastMessage = toastMessages.withReload;
                    result = {
                        "data": {
                            "status": "failure"
                        }
                    };
                }
            } else if (response) {
                let tmpResponseMessage = '';
                if (typeof response === 'string') {
                    tmpResponseMessage = response;
                } else if (typeof response === 'object' && response.data && response.data.error) {
                    tmpResponseMessage = Array.isArray(response.data.error) ? response.data.error.join() : response.data.error;
                }
                let sessionExpired = false;
                if (
                    tmpResponseMessage.indexOf('User ID already in use.') !== -1
                    || tmpResponseMessage.indexOf('Session expired') !== -1
                    || tmpResponseMessage.indexOf('Illegal session id') !== -1
                ) {
                    sessionExpired = true;
                }

                // session expired for devDash
                if (sessionExpired && typeof uStore() !== 'undefined' && reloadOnSessionExiped) {
                    if (state.sessionExpiredTimeout) clearTimeout(state.sessionExpiredTimeout);
                    state.sessionExpiredTimeout = setTimeout(() => {
                        library.showToast('Session expired', { timeout: 60, name: 'sessionExpired' });
                        uStore().logout();
                    }, 1000); // NOSONAR
                    return false;
                }

                // something went wrong except session expired
                if (
                    (tmpResponseMessage.indexOf('Something went wrong') !== -1 || tmpResponseMessage.indexOf('Error message: \'[Microsoft][ODBC Driver 17 for SQL Server][SQL Server]') !== -1)
                    && !sessionExpired
                    && !sDsParams.continueOnFail
                ) {
                    toastMessage = toastMessages.woReload;
                    toastTimeout = 5;
                    reloadOnError = false;
                }
            }
            if (toastMessage) {
                library.showToast(toastMessage, { timeout: toastTimeout });
            }
            if (toastMessage && reloadOnError && toastTimeout) {
                setTimeout(function () {
                    location.href = location.origin + location.pathname;
                }, toastTimeout * 1000); // NOSONAR
            }
            return result;
        },
        async get({ state, commit, dispatch }, payload) {
            let [url, doNotThrowError] = Object.values(payload);
            changeLoadingRequestsCount();
            try {
                if (state.debug && state.repeater && typeof state.lastGet !== "undefined" && state.lastGet.url === url) {
                    return state.lastGet.response;
                }
                let response = await axios.get(url, {/* headers: {
                        "Access-Control-Allow-Origin": "*",
                    } */});
                let currentRequest = {
                    url: url,
                    response: response.data
                };
                // sDs.addRequest({ type: "GET", value: currentRequest });
                changeLoadingRequestsCount(true);
                return response.data;
            } catch (error) {
                changeLoadingRequestsCount(true);
                if (!doNotThrowError) {
                    throw error;
                }
                return false;
            }
        },
        async postJson({ state, commit, dispatch }, payload) {
            let params = Object.values(payload);
            let sDsParams = {};
            let tmpArguments = [...params];
            for (let i = 0; i < tmpArguments.length; i++) {
                if (i === tmpArguments.length - 1 && typeof tmpArguments[i] === 'object' && tmpArguments[i] !== null && tmpArguments[i].sDsParams) {
                    sDsParams = tmpArguments[i].sDsParams;
                    delete tmpArguments[i];
                }
            }
            sDsParams.postAsJson = true;
            tmpArguments.push({ sDsParams: sDsParams });
            return sDs.post.apply(this, tmpArguments);
        },
        async post({ state, commit, dispatch }, payload) {
            // eslint-disable-next-line no-use-before-define
            performanceMonitor.init();
            let params = Object.values(payload);
            let requestOptions;
            if (params[0] && typeof params[0] === 'object' && params[0].sDsFunction) {
                requestOptions = library.cloneObj(params[0]);
                params[0] = params[0].sDsFunction;
            }
            let functionName = params[0];
            let functionParams = {};
            let response;
            let sDsParams = {};
            let fromServer = false;
            for (let i = 1; i < params.length; i++) {
                if (i === params.length - 1 && typeof params[i] === 'object' && params[i] !== null && params[i].sDsParams) {
                    sDsParams = params[i].sDsParams;
                } else {
                    functionParams[i] = params[i];
                }
            }
            if (typeof IS_JEST === 'undefined' && sDsParams.combine && combine.args[functionName]) {
                let isCombinedRequest = false;
                for (let i in combine.args[functionName]) {
                    // run as combined request if combine property is set
                    if (typeof library.getByPath(payload, combine.args[functionName][i]) !== 'undefined') isCombinedRequest = true;
                }
                if (isCombinedRequest) {
                    if (combine.timeouts[functionName]) clearTimeout(combine.timeouts[functionName]);
                    if (!combine.payload[functionName]) {
                        // set the first one
                        combine.payload[functionName] = payload;
                        if (combine.payload?.[functionName]?.[Object.keys(payload)[Object.keys(payload).length - 1]]?.sDsParams?.combine) {
                            // prevent the cycle
                            combine.payload[functionName][Object.keys(payload)[Object.keys(payload).length - 1]].sDsParams.combine = false;
                        }
                    } else {
                        // combine args
                        for (let i in combine.args[functionName]) {
                            let prevValue = library.getByPath(combine.payload[functionName], combine.args[functionName][i], []);
                            let currentValue = library.getByPath(payload, combine.args[functionName][i], []);
                            if (!Array.isArray(prevValue)) prevValue = [prevValue];
                            if (!Array.isArray(currentValue)) currentValue = [currentValue];
                            library.setByPath(combine.payload[functionName], combine.args[functionName][i], [...prevValue, ...currentValue]);
                        }
                    }
                    if (!combine.promises[functionName]) {
                        // set promise for the first request, other requests waiting first promise
                        combine.promises[functionName] = new Promise((resolve) => {
                            combine.resolves[functionName] = resolve;
                        });
                    }
                    // reset timeout, and resolve only after 1 seconds from the last request
                    combine.timeouts[functionName] = setTimeout(() => {
                        let tmpPayload = library.cloneObj(combine.payload[functionName]);
                        delete combine.payload[functionName];
                        delete combine.timeouts[functionName];
                        delete combine.promises[functionName];
                        // after inSeconds of the last request call resolve function of the first request promise
                        combine.resolves[functionName](sDs.post.apply(null, Object.values(tmpPayload)));
                    }, combine.inSeconds * 1000);
                    // return first promise
                    return combine.promises[functionName];
                }
            }
            if (sDsParams.postAsJson) {
                // send parameters as associative massive
                // before next line {1:{orgId:123}}
                // after next line {orgId:123}
                functionParams = functionParams[1];
            }
            if (typeof errorHandler !== 'undefined' && errorHandler.get('isRepeat') && sDsParams && sDsParams.calledFromCId && errorHandler.get('repeatComponentID') === sDsParams.calledFromCId) {
                let lastRequests = errorHandler.get('lastRequests');
                if (lastRequests && lastRequests.length) {
                    let fakeResponse;
                    for (let i in lastRequests) {
                        if (lastRequests[i].fName === functionName && library.isEqualObj(lastRequests[i].fParams, functionParams)) {
                            fakeResponse = lastRequests[i].fResults;
                        }
                    }
                    if (fakeResponse) {
                        return fakeResponse;
                    }
                    return {
                        "status": "failure"
                    };
                }
            }
            changeLoadingRequestsCount();
            try {
                if (state.usePrepared && state.preparedRequests[functionName] && state.preparedRequests[functionName].length) {
                    response = state.preparedRequests[functionName].response[0];
                    let tmpPreparedRequests = state.preparedRequests;
                    tmpPreparedRequests[functionName].push(tmpPreparedRequests[functionName].shift());
                    sDs.mutate('preparedRequests', tmpPreparedRequests);
                    return response;
                }
                let body = {};
                let postData = { postData: { functionName: functionName, functionParams: JSON.stringify(functionParams) } };
                if (typeof PROJECT_NAME !== 'undefined') postData.PROJECT_NAME = PROJECT_NAME;
                if (typeof FROM_LOCALHOST !== 'undefined' && FROM_LOCALHOST && typeof VUE_PROJECT_NAME !== 'undefined') postData.VUE_PROJECT_NAME = VUE_PROJECT_NAME;
                body = { ...postData, ...body };
                let requestKey = functionName + '_' + JSON.stringify(functionParams);
                let isConsistentRequest = state.consistentRequests.indexOf(functionName) !== -1;
                if (isConsistentRequest && state.consistentRequestsQueue[functionName]) {
                    await state.consistentRequestsQueue[functionName];
                    return sDs.post.apply(null, Object.values(payload));
                }
                // if cache enabled for the request and force flag is not turned on
                if (!sDsParams.force && typeof cachedRequests[requestKey] !== 'undefined') {
                    // get the response from the cache
                    response = await cachedRequests[requestKey];
                } else {
                    // if cache disabled or not setted or force flag enabled
                    let request;
                    let saveToCache = () => {
                        cachedRequests[requestKey] = request;
                        let cacheLifeTime = sDsParams.cacheLifeTime || state.cacheLifeTime;
                        if (cacheLifeTime) {
                            setTimeout(() => {
                                // clear queue after state.cacheLifeTime seconds
                                delete cachedRequests[requestKey];
                            }, cacheLifeTime * 1000); // NOSONAR
                        }
                    };
                    // check maybe request with the same params was send already within 3 seconds
                    let isDuplicate = false;
                    if (sDsParams.loadingTargetId) library.showLoadingIndicator(sDsParams.loadingTargetId);

                    if (state.detectFreeze && typeof IS_JEST === 'undefined') {
                        loadingRequestsPerSecond.push({
                            name: functionName,
                            params: functionParams
                        });
                        if (!loadingRequestsPerSecondInterval) {
                            loadingRequestsPerSecondInterval = setInterval(() => {
                                loadingRequestsPerSecond = [];
                            }, 1000);
                        }
                        if (loadingRequestsPerSecond.length >= 50 || freezeDetected) {
                            changeLoadingRequestsCount(true); // decrease because current request will wait
                            if (!freezeDetected) {
                                // send error to email
                                let tmpLoadingRequestsPerSecond = library.cloneObj(loadingRequestsPerSecond);
                                setTimeout(() => {
                                    let tmpMsg = "More than 50 sDs requests were sent per second, can cause slowness";
                                    if (sDsParams && sDsParams.calledFromCId) tmpMsg += " in component " + sDsParams.calledFromCId;
                                    if (requestOptions && requestOptions.subscriptionKey) tmpMsg += " in recordStore";
                                    errorHandler.handle(tmpMsg + ": \n" + JSON.stringify(tmpLoadingRequestsPerSecond, null, 2));
                                }, 1000);
                            }
                            freezeDetected = true;
                            // wait until previous request is load
                            await new Promise((resolve) => {
                                let waitInterval = setInterval(() => {
                                    if (loadingRequestsCount <= 10) {
                                        clearInterval(waitInterval);
                                        resolve();
                                    }
                                }, 500);
                            });
                            freezeDetected = false;
                            changeLoadingRequestsCount();
                            await library.sleep(1000);
                        }
                    }
                    request = axios.post(
                        SDS_URL + "sds.php?" + functionName + (FROM_LOCALHOST ? '&PHPSESSID=' + library.getLocalSessionId() : '')
                        + (FROM_LOCALHOST && library.urlParser.getParams('sisID') ? '&sisID=' + library.urlParser.getParams('sisID') : "")
                        + (requestOptions && requestOptions.subscriptionKey ? '&subscription=' + requestOptions.subscriptionKey : '')
                        + (sDsParams && sDsParams.calledFromCId ? '&cId=' + sDsParams.calledFromCId : ''),
                        qs.stringify(library.flatten(body, { objectAsArray: true }), { arrayFormat: 'comma' })
                    ).catch(async (error) => {
                        if (!state.requestFirstFailTime[requestKey]) state.requestFirstFailTime[requestKey] = new Date().getTime() / 1000; // NOSONAR
                        let currentTime = new Date().getTime() / 1000; // NOSONAR
                        if (currentTime - state.requestFirstFailTime[requestKey] >= 15) { // NOSONAR
                            if (error && error.response && error.response.status && error.response.status === 500) {
                                let tmpReturn = await sDs.responseHandler(functionName, functionParams, sDsParams, false, error.response.status);
                                if (tmpReturn) return tmpReturn;
                            }
                            throw error;
                        }
                        await library.sleep(3000); // NOSONAR
                        delete cachedRequests[requestKey];
                        let dupPost = await sDs.post.apply(null, Object.values(payload));
                        isDuplicate = true;
                        return dupPost;
                    });
                    fromServer = true;
                    if (isConsistentRequest) state.consistentRequestsQueue[functionName] = request;
                    if (typeof IS_JEST === 'undefined') saveToCache();
                    response = await request;
                    if (sDsParams.loadingTargetId) library.hideLoadingIndicator(sDsParams.loadingTargetId);
                    delete state.consistentRequestsQueue[functionName];
                    if (isDuplicate) return response;
                    delete state.requestFirstFailTime[requestKey];
                }

                let tmpReturn = await sDs.responseHandler(functionName, functionParams, sDsParams, response);
                if (tmpReturn) return tmpReturn;

                if (typeof response === 'object' && response.data && response.data.error && !Array.isArray(response.data.error)) {
                    response.data.error = [response.data.error];
                }
                let currentRequest = {
                    name: functionName,
                    params: functionParams,
                    response: response.data
                };
                /* if(typeof devDash != 'undefined') {
                    devDash.addComponentDatasetsLog(currentRequest);
                } */
                // sDs.addRequest({ type: "POST", value: currentRequest });
                changeLoadingRequestsCount(true);
                if (response === 'object') response.data.fromServer = fromServer;
                let lastRequestsByComponent = errorHandler.get('lastRequestsByComponent');
                if (lastRequestsByComponent && sDsParams.calledFromComponent && lastRequestsByComponent[sDsParams.calledFromComponent.cId]) {
                    for (let i in lastRequestsByComponent[sDsParams.calledFromComponent.cId]) {
                        if (library.isEqualObj(lastRequestsByComponent[sDsParams.calledFromComponent.cId][i].fName, functionName) && library.isEqualObj(lastRequestsByComponent[sDsParams.calledFromComponent.cId][i].fParams, functionParams)) {
                            errorHandler.state.lastRequestsByComponent[sDsParams.calledFromComponent.cId][i].fResults = typeof response === 'object' ? response.data : response;
                        }
                    }
                }
                return typeof response === 'object' ? response.data : response;
            } catch (error) {
                changeLoadingRequestsCount(true);
                throw error;
            }
        },
    }
};

store.registerModule("sDs", sDs);

let performanceMonitor = {
    inited: false,
    debugMode: 0,
    limit: 0,
    endpointUrl: SDS_URL + "sDs.php?sds_handleJsError",
    clientUserId: "",
    requests: [],
    jsHttpRequests: [],
    navigationChecked: 0,
    avgTimeReport: {
        'totalTime': 0, 'totalRequests': 0, 'overLimitTime': 0, 'overLimitRequests': 0
    },
    trySendCount: 0,
    imgStart: 0,
    imgEnd: 0,
    allowedProjects: ['signin', 'devDash', 'coordinator'],
    init: () => {
        if (performanceMonitor.inited) return;
        window.performanceMonitor = performanceMonitor;
        performanceMonitor.inited = true;
        // turned off for vueBridge (VUE_PROJECT_NAME = undefined), recruiterBridge
        if (typeof VUE_PROJECT_NAME !== 'undefined' && performanceMonitor.allowedProjects.indexOf(VUE_PROJECT_NAME) !== -1) {
            sDs.post('sds_getPerformanceMonitorSettings').then((response) => {
                if (response.status === 'success' && parseInt(response.data['ENABLE_JS_PERFORMANCE_LOG'], 10) > 0) {
                    performanceMonitor.limit = performanceMonitor.debugMode ? -1 : parseInt(response.data['ENABLE_JS_PERFORMANCE_LOG'], 10);
                    sDs.post('ec_userField', ['CLIENT_USER_NAME']).then((clientResponse) => {
                        if (clientResponse.status === 'success' && typeof clientResponse?.data?.['CLIENT_USER_NAME'] !== 'undefined') {
                            performanceMonitor.clientUserId = response.data['CLIENT_USER_NAME'];
                        }
                        setInterval(() => { performanceMonitor.check(); }, (performanceMonitor.debugMode ? 3000 : 30000));
                        if (response.data['ENABLE_JS_PERFORMANCE_AVG_LOADING_LOG']) {
                            setInterval(() => { performanceMonitor.sendAvgTimeReport(); }, (performanceMonitor.debugMode ? 7000 : 600000));// every 10 minutes
                            library.addUnLoadEvent(performanceMonitor.sendAvgTimeReport);
                        }
                    });
                }
            });
        }
    },
    check: () => {
        if (window && typeof window.performance !== 'undefined' && typeof window.performance.getEntries === 'function') {
            let resourcesTimes = [];
            let errorMessage = '';
            let pEntries = window.performance.getEntries();
            if (typeof performanceMonitor.jsHttpRequests !== 'undefined') {
                for (let i in performanceMonitor.jsHttpRequests) {
                    pEntries.push(performanceMonitor.jsHttpRequests[i]);
                }
            }
            let pWinNavStart = window.performance.timing.navigationStart - window.performance.timeOrigin;
            if (performanceMonitor.debugMode) {
                let theDomLoadTime = ((window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart) / 1000).toFixed(2);
                let theWholePageLoadTime = ((window.performance.timing.loadEventEnd - window.performance.timing.navigationStart) / 1000).toFixed(2);
                // console.log('DOM:'+theDomLoadTime+';PageLoad:'+theWholePageLoadTime); /* @phpstan-ignore-line */
            }
            for (let i = 0; i < pEntries.length; i++) {
                if (!(pEntries[i] instanceof PerformanceResourceTiming || pEntries[i].entryType === 'JSHttpRequest')
                    || pEntries[i].transferSize === 0
                    || (!pEntries[i].name.match(/\.php/i) && pEntries[i].entryType !== 'navigation')
                    || (pEntries[i].entryType === 'navigation' && performanceMonitor.navigationChecked)
                    || (pEntries[i].name.match(/google/i) || pEntries[i].name.match(/atatus/i))
                    || (pEntries[i].name.indexOf('?sds_handleJsError') !== -1)
                    || pEntries[i].name.indexOf('session_validation.php') !== -1
                ) continue; // log only php requests or navigation - whole page load time

                // Also please see errorHandler.js excludeFileNamesFromCallStack and include staff from there if needed

                let entryTime = {};
                entryTime.name = pEntries[i].name;
                entryTime.entryType = pEntries[i].entryType;
                entryTime._addInfo = JSON.parse(JSON.stringify(pEntries[i]));
                entryTime.timeOrigin = window.performance.timeOrigin;
                // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStart
                // responseEnd - the browser receives the last byte of the resource or immediately before the transport connection is closed
                // responseStart -  the browser receives the first byte of the response from the server, cache, or local resource.
                // requestStart -  time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.
                let tmpEndTime = pEntries[i].responseEnd || pEntries[i].responseStart;
                entryTime.loading = ((pEntries[i].transferSize === 0 ? (tmpEndTime - pEntries[i].startTime) : (tmpEndTime - pEntries[i].requestStart)) / 1000).toFixed(2);
                entryTime.isSlow = false;

                if (pEntries[i].entryType === 'navigation' && !performanceMonitor.navigationChecked) { // the HTML whole page load + rendering time;
                    entryTime.navigationStart = window.performance.timing.navigationStart;
                    entryTime.theWholePageTime = ((pEntries[i].loadEventEnd - window.performance.timing.navigationStart + window.performance.timeOrigin) / 1000).toFixed(2);
                    performanceMonitor.navigationChecked = 1;
                } else if (pEntries[i].initiatorType === 'xmlhttprequest') { // ajax
                    if (pEntries[i].name.indexOf('&dnc=') !== -1) {
                        let tmpDnc = pEntries[i].name.split('&dnc=')[1];
                        for (let j = 0; j < performanceMonitor.requests.length; j++) {
                            if (performanceMonitor.requests[j].name.endsWith('&dnc=' + tmpDnc)) {
                                entryTime._requestUrl = performanceMonitor.requests[j].name;
                                entryTime._requestParams = performanceMonitor.requests[j].params;
                            }
                        }
                    }
                }

                // eslint-disable-next-line max-len
                if (((entryTime.loading > performanceMonitor.limit && entryTime.loading < 300) || (entryTime.theWholePageTime > performanceMonitor.limit && entryTime.theWholePageTime < 300 && entryTime.theWholePageTime > 0)) // and less than 5 minutes (300 seconds) - false positive when leaving chrome tab or computer
                ) {
                    errorMessage += '\n' + (entryTime.theWholePageTime ? 'Page Load:' + entryTime.theWholePageTime : entryTime.loading) + ' sec - ' + entryTime.name + ' ';
                    entryTime.isSlow = true;
                }
                // eslint-disable-next-line no-console
                if (performanceMonitor.debugMode && pEntries[i].entryType === 'JSHttpRequest') console.log('----- JSHttpRequest');/* @phpstan-ignore-line */
                // eslint-disable-next-line no-console
                if (performanceMonitor.debugMode) console.log(entryTime);/* @phpstan-ignore-line */

                let theTime = Math.round(100 * (entryTime.theWholePageTime ? entryTime.theWholePageTime : entryTime.loading)) / 100;
                performanceMonitor.avgTimeReport.totalTime += theTime;
                performanceMonitor.avgTimeReport.totalRequests++;
                if (entryTime.isSlow) {
                    performanceMonitor.avgTimeReport.overLimitTime += theTime;
                    performanceMonitor.avgTimeReport.overLimitRequests++;
                }

                // if(pEntries[i].entryType == 'navigation') {
                // performanceMonitor.avgTimeReport.navigationTime+=Math.round(100*(entryTime.theWholePageTime ? entryTime.theWholePageTime : entryTime.loading))/100;
                // performanceMonitor.avgTimeReport.navigationRequests++;
                // }

                resourcesTimes.push(entryTime);
            }

            if (errorMessage) {
                let performanceLog = {};
                if (navigator && navigator.userAgent) performanceLog.userAgent = navigator.userAgent;
                performanceLog.userID = performanceMonitor.clientUserId;
                performanceLog.windowName = window && window.name ? window.name : false;
                performanceLog.windowTitle = document && document.title ? document.title : false;
                performanceLog.resourcesTimes = resourcesTimes;
                performanceMonitor.connectionSpeedCheck(errorMessage, performanceLog);
            }
            window.performance.clearResourceTimings();
            if (typeof performanceMonitor.jsHttpRequests !== 'undefined') {
                performanceMonitor.jsHttpRequests = [];
            }
        }
    },
    connectionSpeedCheck: (errorMessage, performanceLog) => {
        let imageAddr = 'https://samaritan.com/_speedTest/unit.png';
        let downloadSize = 214888;
        let download = new Image();
        let connectionIsSlow = false;
        download.onload = function () {
            performanceMonitor.imgEnd = (new Date()).getTime();
            let duration = (performanceMonitor.imgEnd - performanceMonitor.imgStart) / 1000;
            let speedMbps = ((((downloadSize * 8) / duration) / 1024) / 1024).toFixed(1);
            performanceLog.networkSpeedTestImg = (speedMbps + 'Mbps');
            connectionIsSlow = duration > 1;
            if (!connectionIsSlow) {
                errorMessage = (connectionIsSlow ? (duration).toFixed(0) + 'x SLOW; ' : '') + 'limit: ' + performanceMonitor.limit + 'sec'
                    + errorMessage;
                performanceMonitor.sendError(errorMessage, performanceLog);
            }
            window.performance.clearResourceTimings();
            if (typeof performanceMonitor.jsHttpRequests !== 'undefined') {
                performanceMonitor.jsHttpRequests = [];
            }
        };

        download.onerror = function (err, msg) {
            performanceMonitor.imgStart = 0;
            performanceMonitor.imgEnd = 0;
            window.performance.clearResourceTimings();
            if (typeof performanceMonitor.jsHttpRequests !== 'undefined') {
                performanceMonitor.jsHttpRequests = [];
            }
            performanceMonitor.sendError(errorMessage, performanceLog);
        };
        performanceMonitor.imgStart = (new Date()).getTime();
        let cacheBuster = '?nnn=' + performanceMonitor.imgStart;
        download.src = imageAddr + cacheBuster;
    },
    sendError: (errorMessage, performanceLog, jsErrorType = 1, messageSubject = '') => {
        if (!messageSubject) messageSubject = 'Slow resources ' + (performanceLog.userID ? 'for user ' + performanceLog.userID + ' ' : '') + 'are found on ' + performanceLog.windowTitle + ' (' + performanceLog.windowName + ') page';
        let xhr = new XMLHttpRequest();
        xhr.open('POST', performanceMonitor.endpointUrl, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        let params = {
            'postData[functionName]': 'sds_handleJsError',
            'postData[functionParams]': JSON.stringify({
                '1': errorMessage, '2': performanceLog, '3': (performanceMonitor.debugMode && jsErrorType !== 4 ? -1 : jsErrorType), '4': messageSubject
            })
        };
        let p = [];
        for (let pname in params) {
            p.push(pname + '=' + escape(params[pname]));
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) return; // data is not ready
            if (xhr.status !== 200 && performanceMonitor.trySendCount < 10) {
                setTimeout(function () { performanceMonitor.trySendCount++; performanceMonitor.sendError(errorMessage, performanceLog, jsErrorType, messageSubject); }, performanceMonitor.trySendCount * 60000);
            }
        };
        xhr.send(p.join('&'));
    },
    sendAvgTimeReport: () => {
        // eslint-disable-next-line no-console
        if (performanceMonitor.debugMode) console.log('==== start performanceMonitorSendAvgTimeReport'); /* @phpstan-ignore-line */
        if (performanceMonitor.avgTimeReport.totalTime > 0) {
            performanceMonitor.avgTimeReport.totalTime = (performanceMonitor.avgTimeReport.totalTime).toFixed(2);
            performanceMonitor.avgTimeReport.overLimitTime = (performanceMonitor.avgTimeReport.overLimitTime).toFixed(2);
            // eslint-disable-next-line no-console
            if (performanceMonitor.debugMode) console.log('==== SEND performanceMonitorSendAvgTimeReport'); /* @phpstan-ignore-line */
            // eslint-disable-next-line no-console
            if (performanceMonitor.debugMode) console.log(performanceMonitor.avgTimeReport);/* @phpstan-ignore-line */
            performanceMonitor.sendError('', JSON.stringify(performanceMonitor.avgTimeReport), 4, 'Performance load time');
        }
        performanceMonitor.avgTimeReport = {
            'totalTime': 0, 'totalRequests': 0, 'overLimitTime': 0, 'overLimitRequests': 0
        };// reset
    }
};

export { sDs };
